import { useState } from "react";
import { FaCaretDown } from "react-icons/fa";

import { CurrencyLabel } from "entities/currency";
import { Currency } from "shared/config";
import { Button } from "shared/ui/button";

import { SelectCurrencyDialog } from "./dialog";

type Props<T extends Currency> = {
  currency: T | undefined;
  disabled?: boolean;
  className?: string;
  options: Currency[];

  onChange: (option: Currency) => void;
};

export const Select = <T extends Currency>(props: Props<T>) => {
  const { currency, className, options, onChange, disabled } = props;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {!currency && (
        <Button
          variant="spearmint"
          size="34"
          onClick={() => {
            setIsOpen(true);
          }}
        >
          Choose token
          <FaCaretDown className="opacity-50" />
        </Button>
      )}
      {currency && (
        <CurrencyLabel
          className={className}
          disabled={disabled}
          variant="button"
          logoURI={currency.logoURI}
          symbol={currency.symbol}
          showIcon
          onClick={() => {
            setIsOpen(true);
          }}
        />
      )}

      <SelectCurrencyDialog
        isOpen={isOpen}
        onIsOpenChange={setIsOpen}
        onSelect={(currency) => {
          setIsOpen(false);
          onChange(currency);
        }}
        options={options}
        selectedSymbol={currency?.symbol}
      />
    </>
  );
};
